import { getLocaleWordContent } from '@/utils/language.util';
import React from 'react';

function HistoryItem({ item, no, StateActions }) {
    var red = item.state === 'DONE' ? true : false;
    // var price = item.state === 'DONE' ? item.p_sale : item.p_price;
    const handleCancel = (e) => {
        if (e) e.preventDefault();
        const params = { b_idx: item.b_idx };
        StateActions.postCancel(params).then((rsp) => {
            if (rsp === 1) {
                alert('ok');
                window.location.reload();
            } else {
                alert(rsp.msg);
            }
        });
    };
    return (
        <tr>
            <td>{no}</td>
            <td className="img_pro">
                <img src={require(`../../../resources/assets/images/product${item.p_no}.png`)} alt="product" />
            </td>
            <td>{item.date}</td>
            <td className={red ? 'red' : ''}>
                {red ? (
                    'DONE'
                ) : (
                    <button className="b_blue btn01" onClick={handleCancel}>
                        {getLocaleWordContent('취소')}
                    </button>
                )}
            </td>
        </tr>
    );
}
export default HistoryItem;
